var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.00008C3.10457 4.00008 4 3.10463 4 2.00004C4 0.895449 3.10457 0 2 0C0.895431 0 0 0.895449 0 2.00004C0 3.10463 0.895431 4.00008 2 4.00008Z",
    fill: "#FF0990"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.004C3.10457 11.004 4 10.1085 4 9.00395C4 7.89936 3.10457 7.00391 2 7.00391C0.895431 7.00391 0 7.89936 0 9.00395C0 10.1085 0.895431 11.004 2 11.004Z",
    fill: "#FF0990"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.0001C3.10457 18.0001 4 17.1046 4 16C4 14.8955 3.10457 14 2 14C0.895431 14 0 14.8955 0 16C0 17.1046 0.895431 18.0001 2 18.0001Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsRed);
export default __webpack_public_path__ + "static/media/dots-red.7fe03abee73228a2bfdbd4f6068cc65e.svg";
export { ForwardRef as ReactComponent };